import React, { Component } from 'react'
import NavigationView from './NavigationView'

class Navigation extends Component {
  state = {
    isOpen: false,
  }

  toggleMenu = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  }

  render() {
    return <NavigationView {...this.state} toggleMenu={this.toggleMenu} />
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js